import React, { useState, useEffect } from "react";
// import Filter from "../../components/Filter/Filter";
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import Banner from "../../components/Banner/Banner";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setLang } from "../../redux/actions/settings";

const Suite = () => {
  const [suiteType, setSuiteType] = useState("");
  useEffect(() => {
    window.scrollTo(0, 0);
    window.location.pathname === "/store/vat-suite"
      ? setSuiteType("VAT Suite")
      : setSuiteType("Customs Suite");
    document.title = suiteType;
  }, []);
  const navigate = useNavigate();
  const navigateTo = (e, route) => {
    e.preventDefault();
    navigate(route);
  };

  const { language } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    if (language === "de" || language === "en") {
      dispatch(setLang(language));
    } else {
      navigate("/not-found");
    }
  }, []);

  // const [isFilterVisible, setIsFilterVisible] = useState(false);
  // const [selectedFilters, setSelectedFilters] = useState([]);
  return (
    <div>
      <BreadCrumbs
        navItems={[
          {
            title: "eClear Store",
            href: `/store/${language}`,
          },
          {
            title: suiteType,
          },
        ]}
      />
      <Banner
        image={require("../../assets/images/eclear_header.jpg")}
        title={suiteType}
      />
      {/* <div className="product-filter">
        <label
          id="filter-button"
          onClick={() => {
            setIsFilterVisible(!isFilterVisible);
          }}
        >
          Filter
        </label>
        <label id="close-filter-button">Clear all filters</label>
        {isFilterVisible && <Filter />}
      </div> */}
      <div className="product-list">
        {suiteType === "VAT Suite" && (
          <div className="col-4">
            <a
              href="#"
              onClick={(e) => {
                navigateTo(e, `/store/${language}/product/clearvat`);
              }}
            >
              <img
                alt="ClearVAT"
                src={require("../../assets/images/ClearVAT.jpg")}
                className="product-img"
              />
            </a>
          </div>
        )}

        {suiteType === "VAT Suite" && (
          <div className="col-4">
            <a
              href="#"
              onClick={(e) => {
                navigateTo(e, `/store/${language}/product/vatrules`);
              }}
            >
              <img
                alt="VATRules"
                src={require("../../assets/images/VATRules.jpg")}
                className="product-img"
              />
            </a>
          </div>
        )}

        {suiteType === "Customs Suite" && (
          <div className="col-4">
            <a
              href="#"
              onClick={(e) => {
                navigateTo(e, `/store/${language}/product/clearcustoms`);
              }}
            >
              <img
                alt="ClearCustoms"
                src={require("../../assets/images/ClearCustoms.jpg")}
                className="product-img"
              />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
export default Suite;
